export const UIData = {
  type: 'tabs',
  name: 'user-access',
  heading: '',
  sub_section_type: 'mixed',
  sub_sections: [
    {
      label: '',
      labelKey: 'Users',
      type: 'data-grid',
      name: 'users',
      expandable: false,
      fields: [
        {
          label: 'Name',
          data_column: 'first_name',
          order: 1,
          sortable: false,
          filterable: false,
          type: 'string'
        },
        {
          label: 'Email',
          data_column: 'email',
          order: 2,
          sortable: false,
          filterable: false,
          type: 'string'
        },
        {
          label: 'Groups',
          data_column: 'group_names',
          order: 3,
          sortable: false,
          filterable: false,
          type: 'string'
        },
        {
          label: 'Action',
          data_column: '',
          show_users_edit_button: true,
          order: 4,
          sortable: false,
          filterable: false,
          color: 'primary',
          is_clickable: true,
          button_text: 'Edit',
          button_text2: 'Delete'
        }
      ],
      add_new: {
        form: {
          module_name: 'user-access',
          title: 'Add New User',
          cta_text: 'Add User',
          all_fields_required: false,
          fields: {
            organization: {
              order: 1,
              grid: {xs: 12},
              heading: ['Organization', 'Organization'],
              placeholder: ['Select Organization Name', ''],
              type: 'select',
              multiple: false,
              sql_data: {
                sql: 'select distinct id,name from [###databaseschema].Organizations where deleted=0',
                variables: [{data_column: '', req_column: ''}],
                schema: ['']
              },
              validation: {min_length: 1, max_length: 200},
              required: true
            },
            first_name: {
              order: 2,
              grid: {xs: 12, md: 6},
              heading: ['First Name', ''],
              placeholder: ['First Name', ''],
              type: 'text',
              validation: {min_length: 1, max_length: 100},
              required: true
            },
            last_name: {
              order: 3,
              grid: {xs: 12, md: 6},
              heading: ['Last Name', ''],
              placeholder: ['Last Name', ''],
              type: 'text',
              validation: {min_length: 1, max_length: 100},
              required: true
            },
            middle_name: {
              order: 4,
              grid: {xs: 12, md: 6},
              heading: ['Middle Name', ''],
              placeholder: ['Middle Name', ''],
              type: 'text',
              validation: {min_length: 0, max_length: 100},
              required: false
            },
            email_id: {
              order: 5,
              grid: {xs: 12, md: 6},
              heading: ['Email ID', ''],
              placeholder: ['Email ID', ''],
              type: 'email',
              validation: {pattern: '^\\S+@\\S+\\.\\S+$'},
              required: true
            },
            epic_user_id: {
              order: 6,
              grid: {xs: 12, md: 6},
              heading: ['Epic User ID', ''],
              placeholder: ['Epic User ID', ''],
              type: 'text',
              validation: {min_length: 0, max_length: 100},
              required: false
            },
            user_group: {
              order: 7,
              grid: {xs: 12, md: 6},
              heading: ['User Group', 'User Group'],
              placeholder: ['Select User Group(s)', ''],
              type: 'select',
              multiple: true,
              sql_data: {
                sql: `SELECT id, name FROM [###databaseschema].UserGroups WHERE deleted = 0 AND application_name = ###applicationName`,
                variables: [
                  {
                    data_column: 'applicationName',
                    req_column: 'applicationName'
                  },
                  {data_column: 'search_text', req_column: 'search_text'}
                ],
                schema: ['']
              },
              validation: {min_length: 1, max_length: 9999},
              required: true
            }
          }
        }
      }
    },
    {
      label: 'User Groups',
      type: 'user-groups',
      name: 'user-groups',
      expandable: false,
      fields: []
    },
    {
      label: 'Roles',
      type: 'roles',
      name: 'roles',
      expandable: false,
      fields: []
    }
  ]
};
